import './index.scss';
import './i18n/config';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { queryClient } from 'lib/queryClient';
import { SnackbarProvider } from 'notistack';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { UnheadProvider } from '@unhead/react/client';

import theme from 'theme';
import { AuthContextProvider } from 'contexts/AuthContext';
import { EventContextProvider } from 'contexts/EventContext';
import { FeedbackContextProvider } from 'contexts/FeedbackContext';
import { GlobalContextProvider } from 'contexts/GlobalContext';
import { createToverHead } from 'hooks/useToverHead';

import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container!);
const head = createToverHead({ appName: 'My Tover' });

root.render(
  <StrictMode>
    <UnheadProvider value={head}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalContextProvider>
            <EventContextProvider>
              <AuthContextProvider>
                <FeedbackContextProvider>
                  <SnackbarProvider anchorOrigin={{ horizontal: 'center', vertical: 'top' }} maxSnack={3}>
                    <App />
                  </SnackbarProvider>
                </FeedbackContextProvider>
              </AuthContextProvider>
            </EventContextProvider>
          </GlobalContextProvider>
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </UnheadProvider>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
